import * as ZoomAuthentication from "../../assets/core-sdk/ZoomAuthentication.js/ZoomAuthentication";
const ZoomSDK  = ZoomAuthentication.ZoomSDK;
declare var $: any;

export const SampleAppUtilities = (() => {

    function displayStatus(message: string) {
      (document.getElementById("status") as HTMLElement).innerHTML = message;
    }

    // Disable buttons to prevent hammering, fade out main interface elements, and shuffle the guidance images.
    function fadeOutMainUIAndPrepareForZoOm() {
      disableAllButtons();
      $(".wrapping-box-container").fadeOut(800);
    }

    function fadeInMainUI() {
      enableAllButtons();
      $(".wrapping-box-container").fadeIn(800);
    }

    function showResultStatusAndMainUI(isSuccess: boolean, zoomSessionResult: ZoomAuthentication.ZoomSessionResult ) {
      SampleAppUtilities.fadeInMainUI();
      if (isSuccess) {
        displayStatus("Success");
      } else {
        let statusString = "Unsuccessful. ";
        if (zoomSessionResult.status === ZoomSDK.ZoomSessionStatus.SessionCompletedSuccessfully) {
          statusString += "Session was completed but an unexpected issue occurred during the network request.";
        } else {
          statusString += ZoomSDK.getFriendlyDescriptionForZoomSessionStatus(zoomSessionResult.status);
        }
        displayStatus(statusString);
      }
    }

    function enableAllButtons() {
      (document.getElementById("liveness-button") as HTMLButtonElement).disabled = false;
    /*  (document.getElementById("enroll-button") as HTMLButtonElement).disabled = false;
      (document.getElementById("authenticate-button") as HTMLButtonElement).disabled = false;
      (document.getElementById("id-scan-button") as HTMLButtonElement).disabled = false;*/

    }

    function disableAllButtons() {
      (document.getElementById("liveness-button") as HTMLButtonElement).disabled = true;
    /*  (document.getElementById("enroll-button") as HTMLButtonElement).disabled = true;
      (document.getElementById("authenticate-button") as HTMLButtonElement).disabled = true;
      (document.getElementById("id-scan-button") as HTMLButtonElement).disabled = true;*/
    }

    function handleErrorGettingServerSessionToken() {
      enableAllButtons();
      displayStatus("Session could not be started due to an unexpected issue during the network request.");
    }


    function generateUUId() {
      //@ts-ignore
      return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      )
    }

    return {
      displayStatus,
      showResultStatusAndMainUI,
      handleErrorGettingServerSessionToken,
      generateUUId,
      enableAllButtons,
      disableAllButtons,
      fadeOutMainUIAndPrepareForZoOm,
      fadeInMainUI
    };
})();
